import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  & > span {
    width: 218px;
    padding: 4px 14px;
    border: 1px solid #cfd4dd;
  }
`;

export const PlaceholdersWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px;
  overflow: auto;
  padding-top: 16px;
  padding-bottom: 16px;
`;

export const PlaceholdersItem = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.primary.grey};
  & > span {
    color: ${({ theme }) => theme.colors.primary.black};
    font-weight: 600;
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 4px;
    & > button {
      display: flex;
      border: none;
      background-color: transparent;
      cursor: pointer;
    }
  }
`;
